import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { StoryEvCarRange } from '../../types/electric-cars-page'
import sharedStyles from '../../landing-feature-electric-cars.module.css'

interface EvRangeProps {
  evRange: StoryEvCarRange
}

export const EvRange = ({ evRange }: EvRangeProps) => {
  const { title, text } = evRange
  const rangeText = renderWithResolver(text)
  return (
    <section>
      <h3 className={sharedStyles.heading}>{title}</h3>
      <div className={sharedStyles.textContent}>{rangeText}</div>
    </section>
  )
}
